import { render, staticRenderFns } from "./YoutubePlayer.vue?vue&type=template&id=3934dc2c&"
import script from "./YoutubePlayer.vue?vue&type=script&lang=js&"
export * from "./YoutubePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports